type ResolvePositions = (body: { roles: string[] }) => {
	unwrap: () => Promise<{ titles: string[] }>;
};

/**
 * Turns the ICP's personas into job titles the people index actually contains.
 *
 * The personas are whatever the user typed in the chat ("CEOs"), and the search
 * matches titles literally — `positions/autocomplete?query=CEOs` answers
 * "Executive Assistant to CEOs", so searching on the raw persona returns the
 * assistants instead of the executives. On failure we keep the personas as
 * written: a rough search beats an empty step.
 */
export const resolveIcpPositions = async (
	personas: string[],
	resolvePositions: ResolvePositions
): Promise<string[]> => {
	if (personas.length === 0) {
		return [];
	}

	try {
		const { titles } = await resolvePositions({ roles: personas }).unwrap();

		return titles.length > 0 ? titles : personas;
	} catch (err) {
		console.error(err);

		return personas;
	}
};
